export const Clinica = {
  nome: 'Clínica',
  cnpj: '00.000.000/0001-00',
  especialidade: 'Especialidades Médicas',
  logoUrl: '/logos/logo-vertical.svg',
  logoHorizontalUrl: '/logos/logo-horizontal.svg',
  whatsapp: '5500000000000',
}
